import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import styles from '../../css/app.css';
import TimelineLite from 'gsap/TimelineLite';
import 'gsap/PixiPlugin';

import appEvents from '../../utils-and-data/events.js';
import { GetSimpleRect } from '../../utils-and-data/utils.js';
import FxLayer from '../partials/fx-layer.js';
import BackgroundGhost from '../animations/background';

// @TODO: move these into config, maybe?
const eventOptions = {
  passive: false,
  capture: true
};

class DeletingText extends Component {
  constructor(props) {
    console.log('Ghost DeletingText starting here')
    console.log('-----------------------')
    super(props);
    this.state = {
      currText: props.paragraphs.join(' '),
      ghosting: false,
    };
    this.initialised = false;
    this.destroyTimer = null;
    this.START_GHOST_TOUCH_THRESHOLD = 10;

    this._onDrawStart = this.onDrawStart.bind(this);
    this._onDrawEnd = this.onDrawEnd.bind(this);
    this._onMouseMove = this.onMouseMove.bind(this);
    this._onTouchMove = this.onTouchMove.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('GHOST props', this.props)
    if (prevProps.order !== this.props.order) {
      this.initOrDestroy();
    }
  }

  onTranslateX = (ev) => {
    console.log('onTranslateX:', ev);
  }

  componentDidMount() {
    this.initOrDestroy(this.props);
    this.period = parseInt(this.props.period, 10) || 2000;
    appEvents.on('translateX', this.onTranslateX);
  }

  componentWillUnmount() {
    this.destroyGhost();
  }

  initOrDestroy() {
    if (this.props.order === 'curr'
      && this.initialised === false) {

      this.initialised = true;
      this.startTimer = setTimeout(() => this.initGhost(), 5);
    } else {
      this.destroyGhost();
    }
  }

  initGhost() {
    console.log('Ghost DeletingText initGhost()');
    this.captureEvents();
    this.props.resetCarousel();
    this.props.setCarouselLock(true);
    this.containerRect = GetSimpleRect(this.containerRef);
    this.container = new PIXI.Container();
    this.bg = new BackgroundGhost(this.props, 'deleting')
    this.container.addChild(this.bg);
    FxLayer.voiceLayer.addChild(this.container);
  }

  destroyGhost() {
    clearTimeout(this.tickTimer);
    clearTimeout(this.startTimer);
    appEvents.removeListener('translateX', this.onTranslateX);

    // Ensure that the z index of the FX layer is correct
    FxLayer.setZIndex(2);

    if (!this.initialised) return;
    if (this.bg) this.bg._destroy();
    if (this.container) this.cleanup();
    this.releaseEvents();
    appEvents.emit('setLighting', { mode: 'light' });
    FxLayer.voiceLayer.clearChildren();
    // FxLayer.stop();
    this.setState({
      ghosting: false,
      typing: false,
      currText: this.props.paragraphs.join(' ')
    });

    this.initialised = false;
  }

  cleanup() {

    // loop through all elements appended to scene and remove them
    while (this.container.children[0]) {
      this.container.removeChild(this.container.children[0]);
    }
  }

  showGhost() {
    console.log('Ghost DeletingText showGhost()');
    FxLayer.setZIndex(1);

    this.setState({ ghosting: true });
    this.deleteStatic()
      .then(() => {
        this.bg.animatedShow(() => {});
        appEvents.emit('setLighting', { mode: 'dark' });
        return this.typeGhost();
      })
      .then(() => {
        this.unlock();
      });
    FxLayer.start();
  }

  unlock() {
    console.log('Ghost Deleting unlock()');
    FxLayer.bounce(() => {
      this.releaseEvents();
      this.props.setCarouselLock(false);
    });
  }

  // define some custom canvas methods:
  captureEvents() {
    this.containerRef.addEventListener('mousedown', this._onDrawStart, this.eventOptions);
    this.containerRef.addEventListener('mouseup', this._onDrawEnd, this.eventOptions);
    this.containerRef.addEventListener('touchstart', this._onDrawStart, this.eventOptions);
    this.containerRef.addEventListener('touchend', this._onDrawEnd, this.eventOptions);
  }

  releaseEvents() {
    this.containerRef.removeEventListener('mouseup', this._onDrawEnd, this.eventOptions);
    this.containerRef.removeEventListener('mousemove', this._onMouseMove, this.eventOptions);
    this.containerRef.removeEventListener('mousedown', this._onDrawStart, this.eventOptions);
    this.containerRef.removeEventListener('touchend', this._onDrawEnd, this.eventOptions);
    this.containerRef.removeEventListener('touchmove', this._onTouchMove, this.eventOptions);
    this.containerRef.removeEventListener('touchstart', this._onDrawStart, this.eventOptions);
  }

  stopAndPrevent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onDrawStart(e) {
    console.log('draw start!');
    this.oldPos = null;
    this.stopAndPrevent(e);

    this.containerRef.addEventListener('mousemove', this._onMouseMove, this.eventOptions);
    this.containerRef.addEventListener('touchmove', this._onTouchMove, this.eventOptions);
  }

  onDrawEnd(e) {
    this.stopAndPrevent(e);
    this.containerRef.removeEventListener('mousemove', this._onMouseMove, this.eventOptions);
    this.containerRef.removeEventListener('touchmove', this._onTouchMove, this.eventOptions);
  }

  onMouseMove(e) {
    this.stopAndPrevent(e);
    let y = e.pageY - this.containerRect.top;
    let x = e.pageX - this.containerRect.left;
    this.onDrawMove(x,y);
  }

  onTouchMove(e) {
    this.stopAndPrevent(e);
    let x = e.touches[0].clientX - this.containerRect.left,
      y = e.touches[0].clientY - this.containerRect.top;
    this.onDrawMove(x,y);
  }

  onDrawMove(x,y) {
    if (!this.oldPos) this.oldPos = { x: x, y: y };

    // Detect if they've dragged enough from the start point
    // to enable the ghost to start:
    if (!this.state.ghosting) {
      if (Math.max(
        Math.abs(this.oldPos.x - x),
        Math.abs(this.oldPos.y - y)
      ) >= this.START_GHOST_TOUCH_THRESHOLD) {

        console.log('show ghost!');
        this.showGhost();
      }
    }
  }

  deleteStatic() {
    this.props.resetCarousel();
    this.setState({ typing: false });
    this.fullText = this.props.paragraphs.join(' ');
    return new Promise((res,rej) => {
      this.isDeleting = true;
      this.tick(res);
    });
  }

  typeGhost() {
    this.props.resetCarousel();
    this.setState({ typing: true });
    this.fullText = this.props.ghost.paragraphs.join(' ');
    return new Promise((res,rej) => {
      this.isDeleting = false;
      this.tick(res);
    });
  }

  tick(res) {
    // console.log('ticking');
    let nextText = this.state.currText;
    if (this.isDeleting) {
      nextText = this.fullText.substring(0, nextText.length - 1);
    } else {
      nextText = this.fullText.substring(0, nextText.length + 1);
    }

    // this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';
    this.setState({ currText: nextText });

    // Speed up the deleting of text:
    let delta = this.isDeleting
      ? Math.random() * 70
      : Math.random() * 150

    // Logic to handle the start and end:
    if (!this.isDeleting
      && nextText === this.props.ghost.paragraphs.join(' ')) {

      // Finished typing something out!
      delta = this.period;
      this.isDeleting = true;
      res();
    } else if (this.isDeleting && nextText === '') {

      // Finished deleting something!
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
      res();
    } else {

      // Loop back and run again:
      this.tickTimer = setTimeout((res) => this.tick(res), delta, res);
    }
  }

  storeRef(type, el) {
    // console.log('store a ref:', el);
    if (el !== null) this[type] = el;
  }

  render() {
    return (
      <div styleName='deleting-text'
        className={ClassNames(this.props.order, {
          'ghost-typing': this.state.typing
        })}
        ref={s => this.storeRef('containerRef', s)}>

        <div className='inner'>
          <ReactMarkdown source={this.state.currText} />
        </div>
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(DeletingText, styles);
// export default DeletingText;



// WEBPACK FOOTER //
// ./app/frontend/components/panels/ghost-deleting-text.jsx